import React from "react";
import EventDetails from "./EventDetailsData";
import "./Eventinfo.css";

function EventInfo() {
  const params = new URL(document.location).searchParams;
  const EventName = params.get("name");

  return (
    <div>
      {EventDetails.map((sdata, i) => {
        if (sdata.name === EventName) {
          return (
            <div
              className="container"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                width: "60vw",
              }}
            >
              <img className="eventcard-img mt-5" alt="" src={sdata.image} />
              <div class="event-name">
                <h1>{sdata.title}</h1>
              </div>
              <div className="event-card">
                <h1 class="event-heading">About</h1>
                <p className="paragraph">{sdata.details}</p>
              </div>
              <div className="event-card">
                <h1 class="event-heading">Rules For Event</h1>
                <p className="paragraph">{sdata.rules}</p>
              </div>
            </div>
          );
        }
      })}
    </div>
  );
}

export default EventInfo;
